export default [
  {
    path: 'acciones-movimientos/enrutamiento',
    name: 'enrutamiento',
    component: () =>
      import(
        /* webpackChunkName: "rolesList" */ './views/Enrutamiento.vue'
      ),
  },
];
